module.exports = "/_next/static/images/ActImage@2x-1f419f901a892274dc52e12edf4be7a7.png";